import { logger, LoggerFields } from "./logger";

export const applyMock = <T>(
  data: T,
  setter: (data: T) => void,
  name: string,
) => {
  if (data) {
    setter(data);
    logger[LoggerFields.Group](`Mock data provided for: ${name}`);
    logger[LoggerFields.Log](data);
    logger[LoggerFields.GroupEnd]();
  } else {
    logger.error("No data provided");
  }
};
